export default __webpack_public_path__ + "static/media/Group 5851@2x.2966396e.png";